import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { GridWrapper } from './styles';
import { AgGridReact, AgGridColumnProps, AgGridColumnGroupProps } from 'ag-grid-react';
import {
    IHeaderParams, GridApi, ColumnApi, GridReadyEvent,
    ValueGetterParams, FirstDataRenderedEvent, ICellRendererParams, SortChangedEvent, GridSizeChangedEvent
} from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';

import { HistogeneticsCategory } from '@nkr/enums/index';
import { IHistogeneticsRequest } from '@nkr/models/index';

type MyColumn = AgGridColumnProps | AgGridColumnGroupProps;

const getEntityType = (entityType: number) => {
    switch (entityType) {
        case 1: return 'Voucher Holder';
        case 2: return 'Donor';
        case 3: return 'Recipient';
        default: return 'unknown';
    }
};

interface IProps {
    reportList: IHistogeneticsRequest[],
    selectedTab: HistogeneticsCategory
}

interface IState { }

class HistogeneticslReportGrid extends React.Component<IProps, {}> {
    readonly state: IState = {}

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;

        e.api.sizeColumnsToFit();
    }

    componentDidMount = () => { }

    onGridSizeChanged = (e: GridSizeChangedEvent) => {
        // get the current grids width
        let gridWidth = document.getElementById('grid-wrapper').offsetWidth;

        // keep track of which columns to hide/show
        let columnsToShow = [];
        let columnsToHide = [];

        // iterate over all columns (visible or not) and work out
        // now many columns can fit (based on their minWidth)
        let totalColsWidth = 0;
        let allColumns = this.gridColumnApi.getAllColumns();

        for (let i = 0; i < allColumns.length; i++) {
            let column = allColumns[i];
            totalColsWidth += column.getMinWidth();

            if (totalColsWidth > gridWidth) {
                columnsToHide.push(column.getColId);
            } else {
                columnsToShow.push(column.getColId);
            }
        }

        // show/hide columns based on current grid width
        e.columnApi.setColumnsVisible(columnsToShow, true);
        e.columnApi.setColumnsVisible(columnsToHide, false);

        // fill out any available space to ensure there are no gaps
        e.api.sizeColumnsToFit();
    }

    render = () => {
        if (this.props.reportList == null)
            return null;

        const reportDonorHighResTTColumns: MyColumn[] = [
            {
                colId: 'Rank',
                field: 'rank',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Row #
                    </SortableHeaderComponent>,
                headerName: 'Row #',
                width: 55,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                resizable: true,
                suppressSizeToFit: true,
                valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
            },
            {
                colId: 'id',
                field: 'id',
                headerName: 'ID',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        ID
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'type',
                field: 'type',
                headerName: 'Type',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Type
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'donorAlias',
                field: 'donorAlias',
                headerName: 'Donor Alias',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Donor Alias
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'donorFirstName',
                field: 'donorFirstName',
                headerName: 'Donor First Name',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Donor First Name
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'donorLastName',
                field: 'donorLastName',
                headerName: 'Donor Last Name',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                minWidth: 100,
                maxWidth: 120,
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Donor Last Name
                    </SortableHeaderComponent>,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'uploadDate',
                field: 'uploadDate',
                headerName: 'Upload Date',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Upload Date
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true,
                cellRendererFramework: (props: ICellRendererParams) => {
                    var uploadDate = props.data.uploadDate;
                    return (moment(uploadDate).format('MM/DD/YYYY'))
                }
            }
        ];

        const reportRecipientHighResTTColumns: MyColumn[] = [
            {
                colId: 'Rank',
                field: 'rank',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Row #
                    </SortableHeaderComponent>,
                headerName: 'Row #',
                width: 55,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                resizable: true,
                suppressSizeToFit: true,
                valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
            },
            {
                colId: 'id',
                field: 'id',
                headerName: 'ID',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        ID
                    </SortableHeaderComponent>,

                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'type',
                field: 'type',
                headerName: 'Type',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Type
                    </SortableHeaderComponent>,

                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'recipientAlias',
                field: 'recipientAlias',
                headerName: 'Recipient Alias',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Recipient Alias
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'recipientFirstName',
                field: 'recipientFirstName',
                headerName: 'Recipient First Name',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Recipient First Name
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'recipientLastName',
                field: 'recipientLastName',
                headerName: 'Donor Last Name',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                minWidth: 100,
                maxWidth: 120,
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Recipient Last Name
                    </SortableHeaderComponent>,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'uploadDate',
                field: 'uploadDate',
                headerName: 'Upload Date',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Upload Date
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true,
                cellRendererFramework: (props: ICellRendererParams) => {
                    var uploadDate = props.data.uploadDate;
                    return (moment(uploadDate).format('MM/DD/YYYY'))
                }
            }
        ];

        const reportFVHighResTTColumns: MyColumn[] = [
            {
                colId: 'Rank',
                field: 'rank',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Row #
                    </SortableHeaderComponent>,
                headerName: 'Row #',
                width: 55,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                resizable: true,
                suppressSizeToFit: true,
                valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
            },
            {
                colId: 'id',
                field: 'id',
                headerName: 'ID',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        ID
                    </SortableHeaderComponent>,

                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'voucherFirstName',
                field: 'voucherFirstName',
                headerName: 'Voucher First Name',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Voucher First Name
                    </SortableHeaderComponent>,

                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'voucherLastName',
                field: 'voucherLastName',
                headerName: 'Voucher Last Name',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Voucher Last Name
                    </SortableHeaderComponent>,

                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'donorAlias',
                field: 'donorAlias',
                headerName: 'Donor Alias',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Donor Alias
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'resultsDateTime',
                field: 'resultsDateTime',
                headerName: 'Results Date',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                minWidth: 100,
                maxWidth: 120,
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Results Date
                    </SortableHeaderComponent>,
                sortable: true,
                // sort: 'asc',
                resizable: true,
                cellRendererFramework: (props: ICellRendererParams) => {
                    var resultsDateTime = props.data.resultsDateTime;
                    return (moment(resultsDateTime).format('MM/DD/YYYY'))
                }
            }
        ];

        const reportCryoReceivedColumns: MyColumn[] = [
            {
                colId: 'Rank',
                field: 'rank',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Row #
                    </SortableHeaderComponent>,
                headerName: 'Row #',
                width: 55,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                resizable: true,
                suppressSizeToFit: true,
                valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
            },
            {
                colId: 'id',
                field: 'id',
                headerName: 'ID',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        ID
                    </SortableHeaderComponent>,

                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'type',
                field: 'type',
                headerName: 'Type',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Type
                    </SortableHeaderComponent>,

                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'donorAlias',
                field: 'donorAlias',
                headerName: 'Donor Alias',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Donor Alias
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'donorFirstName',
                field: 'donorFirstName',
                headerName: 'Donor First Name',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Donor First Name
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'donorLastName',
                field: 'donorLastName',
                headerName: 'Donor Last Name',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Donor Last Name
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'orderDateTime',
                field: 'orderDateTime',
                headerName: 'Order Date Time',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Order Date Time
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true,
                cellRendererFramework: (props: ICellRendererParams) => {
                    var orderDateTime = props.data.orderDateTime;
                    return (moment(orderDateTime).format('MM/DD/YYYY'))
                }
            }
        ];

        const reportCryoShippedColumns: MyColumn[] = [
            {
                colId: 'Rank',
                field: 'rank',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Row #
                    </SortableHeaderComponent>,
                headerName: 'Row #',
                width: 55,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                resizable: true,
                suppressSizeToFit: true,
                valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
            },
            {
                colId: 'id',
                field: 'id',
                headerName: 'ID',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        ID
                    </SortableHeaderComponent>,

                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'donorAlias',
                field: 'donorAlias',
                headerName: 'Donor Alias',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Donor Alias
                    </SortableHeaderComponent>,

                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'recipientAlias',
                field: 'recipientAlias',
                headerName: 'Recipient Alias',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Recipient Alias
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'shipBackDate',
                field: 'shipBackDate',
                headerName: 'Shipped Back Date',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Shipped Back Date
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true,
                cellRendererFramework: (props: ICellRendererParams) => {
                    var shipBackDate = props.data.shipBackDate;
                    return (moment(shipBackDate).format('MM/DD/YYYY'))
                }
            }
        ];

        const reportAboUploadsColumns: MyColumn[] = [
            {
                colId: 'Rank',
                field: 'rank',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Row #
                    </SortableHeaderComponent>,
                headerName: 'Row #',
                width: 55,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                resizable: true,
                suppressSizeToFit: true,
                valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
            },
            {
                colId: 'Id',
                field: 'Id',
                headerName: 'ID',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        ID
                    </SortableHeaderComponent>,

                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'dateUploaded',
                field: 'dateUploaded',
                headerName: 'Date Uploaded',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Date Uploaded
                    </SortableHeaderComponent>,

                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true,
                cellRendererFramework: (props: ICellRendererParams) => {
                    var dateUploaded = props.data.dateUploaded;
                    return (moment(dateUploaded).format('MM/DD/YYYY'))
                }
            },
            {
                colId: 'vendor',
                field: 'vendor',
                headerName: 'Vendor',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Vendor
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'entityType',
                field: 'entityType',
                headerName: 'Entity Type',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Entity Type
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true,
                cellRendererFramework: (params: ICellRendererParams) => <>{getEntityType(params.value)}</>,
            },
            {
                colId: 'entityTypeId',
                field: 'entityTypeId',
                headerName: 'Entity Type Id',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Entity Type Id
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'aliasId',
                field: 'aliasId',
                headerName: 'Alias',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Alias
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'entityAboAtUpload',
                field: 'entityAboAtUpload',
                headerName: 'ABO Uploaded',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        ABO Uploaded
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'aboAtUpload ',
                field: 'aboAtUpload',
                headerName: 'ABO At Upload',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        ABO At Upload
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'currentAbo',
                field: 'currentAbo',
                headerName: 'Current ABO',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Current ABO
                    </SortableHeaderComponent>,
                minWidth: 100,
                maxWidth: 120,
                sortable: true,
                // sort: 'asc',
                resizable: true
            },
            {
                colId: 'discrepancyAtUpload',
                field: 'discrepancyAtUpload',
                headerName: 'Discrepancy At Upload',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Discrepancy At Upload
                    </SortableHeaderComponent>,
                minWidth: 120,
                maxWidth: 140,
                sortable: true,
                // sort: 'asc',
                resizable: true
            }
        ];

        const coldef = this.props.selectedTab == HistogeneticsCategory.DonorHighResTT ? reportDonorHighResTTColumns :
            this.props.selectedTab == HistogeneticsCategory.RecipientHighResTT ? reportRecipientHighResTTColumns :
                this.props.selectedTab == HistogeneticsCategory.FVHighResTT ? reportFVHighResTTColumns :
                    this.props.selectedTab == HistogeneticsCategory.CryoReceived ? reportCryoReceivedColumns :
                        this.props.selectedTab == HistogeneticsCategory.AboUploads ? reportAboUploadsColumns : reportCryoShippedColumns;

        return (
            <>
                <div className='row'>
                    <div className='col-sm-12'>
                        <GridWrapper id='grid-wrapper' className='ag-theme-bootstrap'>
                            <AgGridReact
                                enableCellTextSelection={true}
                                enableRangeSelection={true}
                                columnDefs={coldef}
                                rowData={this.props.reportList}
                                headerHeight={30}
                                noRowsOverlayComponentFramework={() =>
                                    <div>No data for the selected date range...</div>}
                                suppressCellSelection={true}
                                onGridReady={this.onGridReady}
                                onGridSizeChanged={this.onGridSizeChanged}
                                onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                                onSortChanged={(e: SortChangedEvent) => { e.api.refreshCells(); }}
                            />
                        </GridWrapper>

                    </div>
                </div>

            </>
        );
    }
}

export default HistogeneticslReportGrid;